$(document).ready(function () {
    $(".featured-image-container .featured-img").first().addClass("active");
    $(".thumbnails-container .thumb-img").on("click", function () {
        var i = $(this).data("img-id");
    });
    const trigger = document.documentElement.clientWidth > 992 ? 'hover focus' : 'click'
    $('[data-toggle="tooltip"]').each(function () {
        $(this).tooltip({
            trigger: trigger,
            container: $(this)
        })
    })
});

function setGiftMessages() {
    const data = localStorage.getItem('_cke-state-vue');
    const state = data ? JSON.parse(data) : { localLineItems: {} };

    const giftForms = document.querySelectorAll('.product-gift');
    giftForms.forEach(form => {
        if(!state.localLineItems[form.dataset.giftId] || !state.localLineItems[form.dataset.giftId] || !state.localLineItems[form.dataset.giftId].properties) {
            return;
        }
        const lineItemProperties = state.localLineItems[form.dataset.giftId].properties;

        let _gift_first_name = form.querySelector('[name="properties[_gift_first_name]"]');
        let _gift_last_name = form.querySelector('[name="properties[_gift_last_name]"]');
        let message = form.querySelector('[name="properties[Message]"]');

        if(_gift_first_name && lineItemProperties._gift_first_name) {
            _gift_first_name.value = lineItemProperties._gift_first_name;
        }
        if(_gift_last_name && lineItemProperties._gift_last_name) {
            _gift_last_name.value = lineItemProperties._gift_last_name;
        }
        if(message && lineItemProperties.Message) {
            message.value = lineItemProperties.Message;
        }

        let productBoxTitle = form.closest('.cart-product-box').querySelector('.top-line .gift-to');

        if (_gift_first_name && _gift_first_name.value ) {
            productBoxTitle.innerHTML = 'Gift for ' + _gift_first_name.value + ' ' + _gift_last_name.value + ' - ';
        } else {
            productBoxTitle.innerHTML = "Gift for Myself - ";
        }
    })
}

document.addEventListener('cart:refresh', setGiftMessages);
document.addEventListener('DOMContentLoaded', setGiftMessages);

document.addEventListener('focus', function(e) {
    if (!e.target) return;
    if (e.target.name === 'properties[_gift_first_name]') {
        if (localStorage.recipients) {
            let autocomplete = e.target.closest('.col').querySelector('.autocomplete-recipients');
            let recipients = JSON.parse(localStorage.recipients).filter(i => i.first_name && i.last_name);
            let list = '';
            for (let i = 0; i < recipients.length; i++) {
                list += `<li class="autocomplete-recipients__item" data-first-name="${recipients[i].first_name}" data-last-name="${recipients[i].last_name}">${recipients[i].first_name} ${recipients[i].last_name}</li>`;
            }
            autocomplete.innerHTML = list;
            autocomplete.style.display = 'block';
            let searchList = [...e.target.closest('.col').querySelectorAll('.autocomplete-recipients li')];
            let value = e.target.value;
            if (value) {
                searchList.map(item =>  {
                    item.style.display = "block";
                    if (!item.textContent.toLowerCase().includes(value.toLowerCase()) ) {
                        item.style.display = "none";
                    }
                })
            }
        }
    }
}, true);
document.addEventListener('blur', function(e) {
    if (!e.target) return;
    if (e.target.name === 'properties[_gift_first_name]') {
            let autocomplete = e.target.closest('.col').querySelector('.autocomplete-recipients');
            setTimeout(function () {
                autocomplete.style.display = 'none';
            }, 200)
    }
}, true);
document.addEventListener('click', function(e) {
    if (!e.target)  return;

    if (e.target.classList.contains('autocomplete-recipients__item')) {
        const giftFirstName = e.target.closest('.col').querySelector('input[name="properties[_gift_first_name]"]');
        const giftLastName = giftFirstName.parentNode.parentNode.querySelector('input[name="properties[_gift_last_name]"]');
        giftFirstName.value = e.target.dataset.firstName;
        giftLastName.value = e.target.dataset.lastName;
        giftFirstName.dispatchEvent(new Event('change', { bubbles: true }));
        giftLastName.dispatchEvent(new Event('change', { bubbles: true }));
    }
});
document.addEventListener('input', function(e) {
    if (!e.target)  return;
    if (e.target.name === 'properties[_gift_first_name]') {
        let searchList = [...e.target.closest('.col').querySelectorAll('.autocomplete-recipients li')]
        let value = e.target.value;
        if (value) {
            searchList.map(item =>  {
                item.style.display = "block";
                if (!item.textContent.toLowerCase().includes(value.toLowerCase()) ) {
                    item.style.display = "none";
                }
            })
        } else {
            searchList.map(e => e.style.display = "block" )
        }
    }
    if (e.target.classList.contains('textarea-has-count')) {
        let $count = e.target.closest('.product-gift').querySelector('.textarea-count');
        if (!$count) return;
        $count.textContent = e.target.value.length + "/" + e.target.getAttribute('maxlength');
    }

});

document.onkeypress = (e) => {
    if (!e.target)  return;
    if ( e.target.name === 'properties[_gift_first_name]'
        || e.target.name === 'properties[_gift_last_name]'
        || e.target.name === 'properties[Message]') {
        let regexp = /[а-яё]/i;
        if (regexp.test(e.key)) {
            return false
        }
    }
}

document.addEventListener('keyup', function(e) {
    if (!e.target) return;
    if (e.target.classList.contains('textarea-has-count')) {
        let $count = e.target.closest('.product-gift').querySelector('.textarea-count');
        if (!$count) return;
        $count.textContent = e.target.value.length + "/" + e.target.getAttribute('maxlength');
    }
});

let slideUp = (target, duration=500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
    }, duration);
}

let slideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
        display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

document.addEventListener('change', function(e) {
    if (!e.target)  return;
    if (
        e.target.name === 'properties[_gift_first_name]'
        || e.target.name === 'properties[_gift_last_name]'
        || e.target.name === 'properties[Message]'
    ) {
        let parent = e.target.closest('[data-gift-id]');
        let _gift_first_name = parent.querySelector('[name="properties[_gift_first_name]"]');
        let _gift_last_name =parent.querySelector('[name="properties[_gift_last_name]"]');

        let message =parent.querySelector('[name="properties[Message]"]').value;

        const data = localStorage.getItem('_cke-state-vue');
        const state = data ? JSON.parse(data) : {
            localLineItems: {}
        };
        if(!state.localLineItems[parent.dataset.giftId]) {
            state.localLineItems[parent.dataset.giftId] = {
                properties: {}
            }
        }

        if(!state.localLineItems[parent.dataset.giftId].properties) {
            state.localLineItems[parent.dataset.giftId].properties = {};
        }

        if(_gift_first_name) {
            state.localLineItems[parent.dataset.giftId].properties._gift_first_name = _gift_first_name.value;
        }
        if(_gift_last_name) {
            state.localLineItems[parent.dataset.giftId].properties._gift_last_name = _gift_last_name.value;
        }
        if( _gift_last_name && _gift_first_name ) {
            let to = _gift_first_name.value + ' ' + _gift_last_name.value;
            state.localLineItems[parent.dataset.giftId].properties.To = to;
        }
        state.localLineItems[parent.dataset.giftId].properties.Message = message;

        localStorage.setItem('_cke-state-vue', JSON.stringify(state));
    }
});

function clearGiftMessage(id) {
    if (!id) return;
    let gifts = localStorage.gifts ?  JSON.parse(localStorage.gifts): {};
    if (typeof gifts[id] != "undefined") {

        delete gifts[id];
        localStorage.setItem('gifts', JSON.stringify(gifts));
        let giftBlock = document.querySelector('[data-gift-id="'+id+'"]')
        let to = giftBlock.querySelector('[name="properties[To]"]');
        let from = giftBlock.querySelector('[name="properties[From]"]');
        let message = giftBlock.querySelector('[name="properties[Message]"]');
        giftBlock.querySelector('.checkbox__input').checked = false;
        to.value = '';
        from.value = '';
        message.value = '';
    }
}

const is = (el, selector) => {
    if (el.matches(selector)) {
        return el;
    }

    return el.closest(selector);
};

document.addEventListener("DOMContentLoaded", function (){
    const selectors = {
        cartItem: '.Cart__ItemList .cart-product-box',
        duplicateItem: '[data-action="duplicate-item"]',
    };

    document.addEventListener('click', function (e) {
        // duplicate item
        if (is(e.target, selectors.duplicateItem)) {
            e.preventDefault();
            e.stopPropagation();

            const link = is(e.target, selectors.duplicateItem);
            const variant_id = link.dataset.variant;
            const rawProperties = link.dataset.properties ? JSON.parse(link.dataset.properties) : [];
            const properties = {};
            if (rawProperties && rawProperties.length) {
                for (let i = 0; i < rawProperties.length; i++) {
                    if (rawProperties[i][0].includes('| sku')) {
                        properties[rawProperties[i][0].replace('&amp;', '&')] = rawProperties[i][1];
                    }
                }
            }
            properties._duplicate = Date.now();

            document.dispatchEvent(new CustomEvent('theme:loading:start'));
            fetch('/cart/add.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variant_id,
                        quantity: 1,
                        properties
                    }]
                }),
            }).then(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
        }
    });
});

